import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Brain, Map, Zap, UploadCloud } from 'lucide-react'
import styled from 'styled-components'
import ToolCard from './ToolCard'

interface ToolsSelectionProps {
  onToolSelect: (toolKey: string) => void
}

const SelectionContainer = styled(Container)`
  padding: 2rem 0;
  max-width: 1200px;
`

const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`

const PageSubtitle = styled.p`
  color: var(--bs-secondary);
  font-size: 1.1rem;
  margin-bottom: 3rem;
`

const tools = [
  {
    key: 'Inferencing',
    title: 'Inferencing',
    description:
      'Run real-time predictions with your trained models. Deploy and test your AI models on new data.',
    icon: Zap,
  },
  {
    key: 'AAL',
    title: 'Adaptive Active Labeling',
    description:
      'Intelligent labeling with AI assistance. Accelerate your annotation workflow with active learning.',
    icon: Brain,
  },
  {
    key: 'Map',
    title: 'Map View',
    description:
      'Visualize geospatial data and predictions. Work with maps and run inference on geographic imagery.',
    icon: Map,
  },
  {
    key: 'SendToClassification',
    title: 'Send to Classification',
    description:
      'Export bounding box snippets from object detection projects to classification projects for further training.',
    icon: UploadCloud,
  },
]

const ToolsSelection: React.FC<ToolsSelectionProps> = ({ onToolSelect }) => {
  return (
    <SelectionContainer>
      <PageTitle>Tools</PageTitle>
      <PageSubtitle>Select a tool to get started</PageSubtitle>

      <Row className="g-4">
        {tools.map((tool) => (
          <Col key={tool.key} xs={12} md={6} lg={4}>
            <ToolCard
              title={tool.title}
              description={tool.description}
              icon={tool.icon}
              onClick={() => onToolSelect(tool.key)}
            />
          </Col>
        ))}
      </Row>
    </SelectionContainer>
  )
}

export default ToolsSelection
